import { PATH_THANKYOU } from "../../constants/Paths";
import {
  proceedEditOrderToServer,
  proceedOrderToServer,
} from "../../logic/server/OrderFunction";
import {
  buildAmendOrderPayload,
  buildOrderPayloadV2,
} from "../../logic/server/PayloadBuilder";

// 28/Jun/2024 VE - New Function
//

export const submitEditOrder = async (
  utils,
  user,
  order,
  cartItems,
  existingOrder,
  existingOrderCartItems,
  additionalItems = null,
  selectedStore = null
) => {
  const { webApp, sessionToken, navigate } = utils;
  try {
    const {
      userId,
      userName,
      agentId,
      routeDetails,
      customerName,
      customerContact,
      customerAddress,
      timeSlot,
      customerComments,
    } = user;

    const {
      isDeliveryWaived,
      discountAmount,
      deliveryCost,
      surchargeCost,
      paymentCost,
      storeTotalCost,
      charges,
    } = order;

    const userDetails = {
      userId: userId,
      userName: userName,
    };

    const postalCodeDetails = {
      address: customerAddress,
      postalCodeDescr: routeDetails.postalcodedescr,
    };

    const featureFlags = {
      isDeliveryWaived,
    };

    const orderCosts = {
      discountAmount: discountAmount,
      deliveryCost: deliveryCost,
      surchargeCost: surchargeCost,
      baseCost: paymentCost,
      storeTotalCost: storeTotalCost,
      charges: charges,
    };

    const customerDetails = {
      orderName: customerName,
      orderPhone: customerContact,
      orderAddress: customerAddress,
      orderComments: customerComments,
    };

    // Send complete cartItems to backend for database processing
    // Backend will handle filtering changes for broadcast messages using filterCartDifferences
    console.log(`[submitEditOrder] Sending complete cartItems to backend: ${cartItems.length} items for database processing`);
    
    if (additionalItems && additionalItems.length > 0) {
      const additionalInfo = additionalItems.map(item => 
        `${item.title}: ${item.quantity}x${item.isQuantityIncrease ? ` (was ${item.originalQuantity}, now ${item.newQuantity})` : ' (new item)'}`
      ).join(', ');
      console.log(`[submitEditOrder] Detected changes: ${additionalInfo}`);
    }
    
    const orderSummary = buildAmendOrderPayload(
      userDetails,
      customerDetails,
      postalCodeDetails,
      featureFlags,
      cartItems,  // Send complete cart items, not just changes
      existingOrder,
      existingOrderCartItems,
      timeSlot,
      orderCosts,
      routeDetails,
      agentId
    );

    const result = await proceedEditOrderToServer(sessionToken, orderSummary, selectedStore);

    // Only navigate to success page if order was actually edited successfully
    if (result && result.success && result.order) {
      navigate(PATH_THANKYOU, {
        replace: true,
      });
    } else {
      // Handle failed order edit
      webApp.MainButton.hideProgress(true);
      webApp.BackButton.show();
      
      const errorMessage = result?.error || "Order edit failed. Please try again.";
      alert(`Order Edit Failed: ${errorMessage}`);
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error("Error sending message:", error);
    webApp.MainButton.hideProgress(true);
    webApp.BackButton.show();
    // Handle the error gracefully, e.g., show an error message to the user
    alert(`${error}`);
  }
};
